/** Keys omitted from template-vars UI (e.g. email unsubscribe token). */
export const TEMPLATE_VARS_EXCLUDED_KEYS = ["UNSUBSCRIBE_TOKEN"] as const;

/** Shown first in lists; remaining keys sort A–Z after these. */
export const TEMPLATE_VARS_SORT_FIRST_KEYS = ["patient_name"] as const;

export const TEMPLATE_VARS_EMPTY_VALUE = "—";

export type TemplateVarEntry = { label: string; value: string };

/** Accept API `templateVars` as object or JSON string. */
export function pickTemplateVarsRecord(
  raw: unknown,
): Record<string, unknown> | undefined {
  if (raw == null) return undefined;
  if (typeof raw === "object" && !Array.isArray(raw))
    return raw as Record<string, unknown>;
  if (typeof raw === "string") {
    try {
      const parsed = JSON.parse(raw) as unknown;
      if (parsed != null && typeof parsed === "object" && !Array.isArray(parsed))
        return parsed as Record<string, unknown>;
    } catch {
      /* ignore */
    }
  }
  return undefined;
}

function formatTemplateVarLabel(key: string): string {
  return key.replace(/_/g, " ").toLowerCase();
}

function formatTemplateVarValue(v: unknown): string {
  // console.log("v", v);
  if (v == null) return TEMPLATE_VARS_EMPTY_VALUE;
  return String(v);
}

function compareTemplateVarKeys(a: string, b: string): number {
  const firstKeys = TEMPLATE_VARS_SORT_FIRST_KEYS as readonly string[];
  const aIndex = firstKeys.indexOf(a);
  const bIndex = firstKeys.indexOf(b);
  if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex;
  if (aIndex !== -1) return -1;
  if (bIndex !== -1) return 1;
  return a.localeCompare(b);
}

/** One label/value row per key for popovers and detail panels. */
export function entriesFromTemplateVars(raw: unknown): TemplateVarEntry[] {
  console.log("raw", raw);
  const vars = pickTemplateVarsRecord(raw);
  if (!vars) return [];

  // const excluded = new Set<string>(TEMPLATE_VARS_EXCLUDED_KEYS);

  return Object.keys(vars)
    .filter((key) => !key.toLowerCase().includes("token"))
    .sort(compareTemplateVarKeys)
    .map((key) => ({
      label: formatTemplateVarLabel(key),
      value: formatTemplateVarValue(vars[key]),
    }));
}
